import React from 'react';

const ChainIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.99748 10.0002L9.99748 6.00022M7.33081 4.00022L7.63948 3.64289C8.26468 3.01778 9.1126 2.66662 9.99671 2.66669C10.8808 2.66675 11.7287 3.01802 12.3538 3.64322C12.9789 4.26843 13.3301 5.11635 13.33 6.00046C13.33 6.88457 12.9787 7.73244 12.3535 8.35756L11.9975 8.66689M8.66416 12.0002L8.39949 12.3562C7.76699 12.9817 6.91335 13.3325 6.02382 13.3325C5.1343 13.3325 4.28066 12.9817 3.64816 12.3562C3.33639 12.048 3.08889 11.6809 2.91996 11.2763C2.75104 10.8717 2.66406 10.4377 2.66406 9.99922C2.66406 9.56079 2.75104 9.12671 2.91996 8.72213C3.08889 8.31754 3.33639 7.95049 3.64816 7.64222L3.99749 7.33356",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
ChainIcon.displayName = "Icons.ChainIcon";

export { ChainIcon };
//# sourceMappingURL=ChainIcon.js.map
